import script from "./OrcamentoProjetoFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrcamentoProjetoFormView.vue?vue&type=script&setup=true&lang=js"

import "./OrcamentoProjetoFormView.vue?vue&type=style&index=0&id=7f3efe8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f3efe8f"]])

export default __exports__